(() => {
  function mount(root) {
    const trigger = root.querySelector('.vp-gallery-zoom');
    if (!trigger || trigger.dataset.zoomReady) return;
    trigger.dataset.zoomReady = 'true';
    const dialog = document.createElement('dialog');
    if (typeof dialog.showModal !== 'function') return;
    dialog.className = 'vp-zoom-dialog';
    dialog.setAttribute('aria-label', 'Enlarged product image');
    const close = document.createElement('button');
    close.type = 'button';
    close.className = 'vp-zoom-close';
    close.setAttribute('aria-label', 'Close enlarged image');
    close.textContent = '×';
    const image = document.createElement('img');
    image.src = trigger.href;
    image.alt = 'VYV product image';
    dialog.append(close, image);
    document.body.append(dialog);
    let previousOverflow = '';
    trigger.addEventListener('click', event => {
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      event.preventDefault();
      const slide = root.querySelector('[data-slide]:not([hidden])');
      image.src = trigger.href;
      image.alt = slide?.querySelector('img[alt]:not([alt=""])')?.alt || slide?.textContent.trim() || 'VYV product image';
      previousOverflow = document.body.style.overflow;
      document.body.style.overflow = 'hidden';
      dialog.showModal();
      close.focus();
    });
    close.addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', event => { if (event.target === dialog) dialog.close(); });
    dialog.addEventListener('close', () => {
      document.body.style.overflow = previousOverflow;
      trigger.focus({ preventScroll: true });
    });
    root.addEventListener('shopify:section:unload', () => { if (dialog.open) dialog.close(); dialog.remove(); });
  }
  function mountAll() { document.querySelectorAll('[data-vyv-product][data-flavor]').forEach(mount); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mountAll);
  else mountAll();
  document.addEventListener('shopify:section:load', mountAll);
})();

(() => {
  const gallery = document.querySelector('#vyv-product[data-flavor] .vp-gallery');
  if (!gallery) return;
  const sync = () => gallery.style.setProperty('--vp-gallery-height', `${gallery.getBoundingClientRect().height}px`);
  new ResizeObserver(sync).observe(gallery);
  sync();
})();

(() => {const badge=document.querySelector('#vyv-product .vp-rating-summary');if(!badge)return;badge.addEventListener('click',()=>{const reviews=document.getElementById('vp-reviews');if(reviews){reviews.setAttribute('tabindex','-1');reviews.focus({preventScroll:true});}});})();
